import React, { Component } from "react";
import { connect } from "react-redux";
import { getSESProducts, deleteSESProduct, setSESProducts } from "../../actions";
import { Container, Row, Col, Button, Form, Table, Badge, Spinner, FormSelect, InputGroup, Image, Modal, Card } from "react-bootstrap";
import { FaEdit, FaTrash, FaCopy, FaHistory, FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { Link } from "react-router-dom";
import ViewModal from "./ViewModal";
import QuantityChangeModal from "./QuantityChangeModal";
import IframeModal from "../../components/IframeModal/IframeModal";
import CloneModal from "./CloneModal";
import { getTranslate, LANGUAGE_KEYS } from "../../utils/language";
import { getToken } from "../../utils/token";
import { getApiUrl } from "../../utils/platform";
import moment from 'moment';
import { USER_GROUPS } from '../../routes';



// Wrapper component to force re-mount when route changes
const SESProductListWrapper = (props) => {
  // Calculate route key dynamically based on current URL
  const getCurrentRouteKey = () => {
    const pathname = window.location.pathname;
    if (pathname.includes('product-rnd-list')) return 'rnd';
    if (pathname.includes('product-list') && !pathname.includes('product-rnd-list') && !pathname.includes('product-sale-list')) return 'warehouse';
    if (pathname.includes('product-sale-list')) return 'sale';
    return 'default';
  };

  const currentRouteKey = getCurrentRouteKey();
  console.log('Current pathname:', window.location.pathname, 'Route key:', currentRouteKey);
  
  return <SESProductList key={currentRouteKey} {...props} />;
};

class SESProductList extends Component {
  // Calculate route type based on current URL
  getRouteType = () => {
    const pathname = window.location.pathname;
    const isRnd = pathname.includes('product-rnd-list');
    const isWarehouse = pathname.includes('product-list') && !pathname.includes('product-rnd-list') && !pathname.includes('product-sale-list');
    const isSale = pathname.includes('product-sale-list');
    
    return { isRnd, isWarehouse, isSale };
  };

  // Helper function to get localStorage key based on route type
  getLocalStorageKey = (baseKey) => {
    const { isRnd, isSale } = this.getRouteType();
    if (isRnd) return `${baseKey}Rnd`;
    if (isSale) return `${baseKey}Sale`;
    return baseKey;
  };

  constructor(props) {
    super(props);
    
    // Calculate route type
    const pathname = window.location.pathname;
    const isRnd = pathname.includes('product-rnd-list');
    const isWarehouse = pathname.includes('product-list') && !pathname.includes('product-rnd-list') && !pathname.includes('product-sale-list');
    const isSale = pathname.includes('product-sale-list');
    
    this.state = {
      loading: false,
      currentPage: 1,
      itemsPerPage: parseInt(localStorage.getItem('sesProductItemsPerPage')) || 20,
      sortBy: 'sku_code',
      sortOrder: 1,
      keyword: '',
      selectedSupplier: localStorage.getItem('sesProductSelectedSupplier') || 'RESIN_HOAI_DUC',
      selectedStatus: localStorage.getItem('sesProductSelectedStatus') || 'ALL',
      columnVisibility: JSON.parse(localStorage.getItem(isRnd ? 'sesProductColumnVisibilityRnd' : isSale ? 'sesProductColumnVisibilitySale' : 'sesProductColumnVisibility')) || {
        image: true,
        skuCode: true,
        size: true,
        style: true,
        productName: true,
        basePrice: true,
        currentQuantity: true,
        currentCellCode: true,
        status: true,
        lastUpdate: true,
        action: true
      },
      showModal: false,
      selectedProductId: null,
      mode: 'create',
      currentProduct: null,
      showQuantityChangeModal: false,
      selectedProductCode: '',
      selectedProductName: '',
      sortedProducts: [],
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: '',
      showCloneModal: false,
      productToClone: null,
      showImageModal: false,
      imageToShow: '',
      showConfigModal: false,
      statsDisplay: isRnd ? false : isSale ? true : true,
      statsDateFilter: isWarehouse ? 'all' : (localStorage.getItem('sesProductStatsDateFilter') || 'today'),
      stats: null,
      hasOrders: isSale ? true : (localStorage.getItem('sesProductHasOrders') === 'true'),
      hasPendingOrders: isSale ? false : (localStorage.getItem('sesProductHasPendingOrders') === 'true'),
      sortType: localStorage.getItem('sesProductSortType') || 'totalOrders',
      safeWeek: parseInt(localStorage.getItem('sesProductSafeWeek')) || 1,
      exporting: false,
      stickHeader: localStorage.getItem(isRnd ? 'sesProductStickHeaderRnd' : isSale ? 'sesProductStickHeaderSale' : 'sesProductStickHeader') === 'true' || false,
    };
  }

  SUPPLIERS = [
    { value: 'ALL', label: 'Tất cả' },
    { value: 'RESIN_HOAI_DUC', label: 'Resin Hoài Đức' },
    { value: 'KSC_RESIN', label: 'KSC Resin' },
    { value: 'WOOD_HIEP_HOA', label: 'Gỗ Hiệp Hòa' },
    { value: 'BREAKWOODEN', label: 'Breakwooden' },
    { value: 'OTHER', label: 'Khác' }
  ];

  STATUS_OPTIONS = [
    { value: 'ALL', label: 'Tất cả' },
    { value: 'ACTIVE', label: 'Hoạt động' },
    { value: 'DEACTIVE', label: 'Không hoạt động' },
    { value: 'RND', label: 'R&D' },
    { value: 'CANCEL', label: 'Hủy' }
  ];

  componentDidMount() {
    const { currentPage, itemsPerPage, sortBy, sortOrder, keyword } = this.state;
    
    // Store current pathname to detect URL changes
    this.currentPathname = window.location.pathname;
    
    // Ensure statsDateFilter is always "all" for warehouse
    const { isWarehouse } = this.getRouteType();
    if (isWarehouse && this.state.statsDateFilter !== 'all') {
      this.setState({ statsDateFilter: 'all' }, () => {
        this.loadProducts();
        this.updateURL({ currentPage, itemsPerPage, sortBy, sortOrder, keyword });
      });
    } else {
      this.loadProducts();
      this.updateURL({ currentPage, itemsPerPage, sortBy, sortOrder, keyword });
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.products) !== JSON.stringify(this.props.products)) {      
      this.setState({ sortedProducts: this.props.products || [] }, () => {
        this.handleSort(this.state.sortBy, false);
      });
    }
    
    // Ensure statsDateFilter is always "all" for warehouse
    const { isWarehouse } = this.getRouteType();
    if (isWarehouse && this.state.statsDateFilter !== 'all') {
      this.setState({ statsDateFilter: 'all' }, this.loadProducts);
    }
  }

  loadProducts = () => {
    const { currentPage, itemsPerPage, sortBy, sortOrder, keyword, statsDisplay, statsDateFilter, hasOrders, hasPendingOrders, selectedSupplier, selectedStatus } = this.state;
    
    this.setState({ loading: true });
    
    const query = {
      currentPage,
      itemsPerPage,
      sortBy,
      sortOrder,
      keyword,
      stats_display: statsDisplay,
      stats_start_date: this.getStatsStartDate(statsDateFilter),
      stats_end_date: this.getStatsEndDate(statsDateFilter),
      has_orders: hasOrders,
      has_pending_orders: hasPendingOrders,
      suppliers: selectedSupplier === 'ALL' ? undefined : selectedSupplier,
      status: selectedStatus === 'ALL' ? undefined : selectedStatus
    };

    this.props.getSESProducts(query)
      .then((res) => {
        if (this.state.statsDisplay && res && res.data && res.data.stats) {
          this.setState({ stats: res.data.stats });
        } else {
          this.setState({ stats: null });
        }
        if (this.state.statsDisplay) {
          setTimeout(this.sortStatsProducts, 0);
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  getStatsStartDate = (filter) => {
    const today = moment();
    let from = '';
    switch (filter) {
      case 'today':
        from = today.format('YYYY-MM-DD');
        break;
      case 'yesterday':
        from = today.clone().subtract(1, 'days').format('YYYY-MM-DD');
        break;
      case 'this_week':
        from = today.clone().startOf('isoWeek').format('YYYY-MM-DD');
        break;
      case 'last_week':
        from = today.clone().subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD');
        break;
      case 'this_month':
        from = today.clone().startOf('month').format('YYYY-MM-DD');
        break;
      case 'last_7_days':
        from = today.clone().subtract(7, 'days').format('YYYY-MM-DD');
        break;
      case 'last_14_days':
        from = today.clone().subtract(14, 'days').format('YYYY-MM-DD');
        break;
      case 'last_30_days':
        from = today.clone().subtract(30, 'days').format('YYYY-MM-DD');
        break;
      case 'last_month':
        from = today.clone().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        break;
      case 'all':
      default:
        from = '2025-06-01';
    }
    return from;
  };

  getStatsEndDate = (filter) => {
    const today = moment();
    let to = '';
    switch (filter) {
      case 'today':
        to = today.format('YYYY-MM-DD');
        break;
      case 'yesterday':
        to = today.clone().subtract(1, 'days').format('YYYY-MM-DD');
        break;
      case 'this_week':
        to = today.clone().endOf('isoWeek').format('YYYY-MM-DD');
        break;
      case 'last_week':
        to = today.clone().subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');
        break;
      case 'this_month':
        to = today.clone().endOf('month').format('YYYY-MM-DD');
        break;
      case 'last_7_days':
        to = today.format('YYYY-MM-DD');
        break;
      case 'last_14_days':
        to = today.format('YYYY-MM-DD');
        break;
      case 'last_30_days':
        to = today.format('YYYY-MM-DD');
        break;
      case 'last_month':
        to = today.clone().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
        break;
      case 'all':
      default:
        to = today.format('YYYY-MM-DD');
    }
    return to;
  };

  updateStatsColumns = (enable) => {
    this.setState(prevState => ({
      columnVisibility: {
        ...prevState.columnVisibility,
        style: !enable ? true : false,
        basePrice: !enable ? true : false,
        size: !enable ? true : false,
        weight: !enable ? true : false,
        lastUpdate: !enable ? true : false,
        action: !enable ? true : false,
        // Có thể ẩn thêm các trường khác nếu cần
      }
    }));
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      this.updateURL({ page });
      this.loadProducts();
    });
  };

  handleSort = (field, toggleOrder = true) => {
    const { sortedProducts } = this.state;
    const sortOrder = (this.state.sortBy === field && toggleOrder) ? -this.state.sortOrder : this.state.sortOrder;

    console.log("handleSort", field, toggleOrder, sortOrder);

    if (field === 'size') {
      // Custom sorting for size with expanded size order
      const sizeOrder = { 'S': 1, 'M': 2, 'L': 3, 'XL': 4, 'XXL': 5, '2XL': 5, 'XXXL': 6, '3XL': 6 };
      const newSortedProducts = [...sortedProducts].sort((a, b) => {
        const sizeA = a.size?.toUpperCase() || '';
        const sizeB = b.size?.toUpperCase() || '';
        const orderA = sizeOrder[sizeA] || 999; // Default to end if size not in order
        const orderB = sizeOrder[sizeB] || 999;
        
        // If sizes have the same order, sort by SKU code
        if (orderA === orderB) {
          return sortOrder * (a.sku_code || '').localeCompare(b.sku_code || '');
        }
        return sortOrder * (orderA - orderB);
      });
      this.setState({ sortedProducts: newSortedProducts });
    } else if (field === 'sku_code') {
      // Sort by SKU code first, then by size
      const sizeOrder = { 'S': 1, 'M': 2, 'L': 3, 'XL': 4, 'XXL': 5, '2XL': 5, 'XXXL': 6, '3XL': 6 };
      const newSortedProducts = [...sortedProducts].sort((a, b) => {
        const skuCompare = sortOrder * (a.sku_code || '').localeCompare(b.sku_code || '');
        if (skuCompare === 0) {
          const sizeA = a.size?.toUpperCase() || '';
          const sizeB = b.size?.toUpperCase() || '';
          const orderA = sizeOrder[sizeA] || 999;
          const orderB = sizeOrder[sizeB] || 999;
          return orderA - orderB;
        }
        return skuCompare;
      });
      this.setState({ sortedProducts: newSortedProducts });
    } else {
      // For other fields, sort normally
      const newSortedProducts = [...sortedProducts].sort((a, b) => {
        const valueA = a[field];
        const valueB = b[field];
        if (typeof valueA === 'string') {
          return sortOrder * valueA.localeCompare(valueB);
        }
        return sortOrder * (valueA - valueB);
      });
      this.setState({ sortedProducts: newSortedProducts });
    }
    
    this.setState(prevState => ({
      sortBy: field,
      sortOrder: sortOrder
    }), () => {
      localStorage.setItem('sortBy', this.state.sortBy);
      localStorage.setItem('sortOrder', this.state.sortOrder);
      this.updateURL({ sort_by: field, sort_order: sortOrder, page: 1 });
    });
  };

  handleSearch = (e) => {
    this.setState({ keyword: e.target.value, currentPage: 1 }, () => {
      this.updateURL({ keyword: e.target.value, page: 1 });
      this.loadProducts();
    });
  };

  handleDelete = (product) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      this.props.deleteSESProduct(product)
        .then(() => {
          // this.handleSort(this.state.sortBy, false);
          // this.loadProducts();
        })
        .catch(error => {
          console.error('Error deleting product:', error);
          alert("Failed to delete product. See console for details.");
        });
    }
  };

  handleView = (product) => {
    console.log("SESProductList handleView", product);
    this.setState({
      showModal: true,
      selectedProductId: product._id,
      mode: 'view',
      currentProduct: product
    });
  };

  handleEdit = (product) => {
    this.setState({
      showModal: true,
      selectedProductId: product._id,
      mode: 'edit',
      currentProduct: product
    });
  };

  handleCreate = () => {
    this.setState({
      showModal: true,
      selectedProductId: null,
      mode: 'edit',  // Always edit mode for new product
      currentProduct: null  // Explicitly set currentProduct to null for new product
    });
  };

  handleClone = (product) => {
    this.setState({
      showCloneModal: true,
      productToClone: product
    });
  };

  handleCloneSubmit = ({ skuCode, size }) => {
    const { productToClone } = this.state;
    
    // Create a clone of the product with updated SKU and size
    const clonedProduct = {
      ...productToClone,
      created_at: undefined,
      updated_at: undefined,
      _id: undefined, // Remove _id to create a new record
      sku_code: skuCode,
      size: size
    };
    
    // Save cloned product
    // this.setState({ loading: true });
    this.props.setSESProducts([clonedProduct], { create_new: true })
      .then(() => {
        // alert(`Product cloned successfully with SKU: ${skuCode} and size: ${size}`);
        // this.loadProducts(); // Reload the product list
        // this.handleSort(this.state.sortBy, false);
      })
      .catch(error => {
        console.error('Error cloning product:', error);
        alert('Failed to clone product. See console for details.');
      })
      .finally(() => {
        this.setState({ 
          loading: false,
          showCloneModal: false,
          productToClone: null
        });
      });
  };

  handleViewQuantityChanges = (product) => {
    this.setState({
      showQuantityChangeModal: true,
      selectedProductCode: product.product_code,
      selectedProductName: product.product_name
    });
  };

  handleViewVersions = (product) => {
    const versionUrl = process.env.REACT_APP_VERSION_URL || '/admin/rnd/product-versions';
    this.setState({
      showIframeModal: true,
      iframeUrl: `${versionUrl}?product_code=${product.product_code}`,
      iframeTitle: 'Product Versions'
    });
  };

  handleShowImage = (imageUrl) => {
    this.setState({ showImageModal: true, imageToShow: imageUrl });
  };

  handleCloseImage = () => {
    this.setState({ showImageModal: false, imageToShow: null });
  };

  handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    localStorage.setItem('sesProductItemsPerPage', newItemsPerPage);
    this.setState({
      itemsPerPage: newItemsPerPage,
      currentPage: 1
    }, () => {
      this.updateURL({ per_page: newItemsPerPage, page: 1 });
      this.loadProducts();
    });
  };

  handleStickHeaderToggle = () => {
    this.setState(prevState => {
      const newStickHeader = !prevState.stickHeader;
      // Save to localStorage
      const { isRnd, isSale } = this.getRouteType();
      localStorage.setItem(isRnd ? 'sesProductStickHeaderRnd' : isSale ? 'sesProductStickHeaderSale' : 'sesProductStickHeader', newStickHeader.toString());
      return { stickHeader: newStickHeader };
    });
  };

  updateURL = (params) => {
    const searchParams = new URLSearchParams(window.location.search);
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value);
      } else {
        searchParams.delete(key);
      }
    });
    const newURL = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({}, '', newURL);
  };

  sortStatsProducts = () => {
    const { sortType } = this.state;
    const { isSale } = this.getRouteType();
    let sorted = [...this.state.sortedProducts];
    
    if (sortType === 'totalOrders') {
      sorted.sort((a, b) => (b.stats?.total_listings || 0) - (a.stats?.total_listings || 0));
    } else if (sortType === 'totalPending') {
      const getPending = p => (p.stats?.processing_sale || 0) + (p.stats?.processing_fulfill || 0);
      sorted.sort((a, b) => getPending(b) - getPending(a));
    } else if (!isSale && sortType === 'diff') {
      const getDiff = p => (p.current_qty || 0) - ((p.stats?.processing_sale || 0) + (p.stats?.processing_fulfill || 0));
      sorted.sort((a, b) => getDiff(a) - getDiff(b));
    } else if (!isSale && sortType === 'chenhSafe') {
      const getChenhSafe = p => {
        const totalOrders = p.stats?.total_listings || 0;
        const diff = (p.current_qty || 0) - ((p.stats?.processing_sale || 0) + (p.stats?.processing_fulfill || 0));
        const startDateStr = this.getStatsStartDate(this.state.statsDateFilter);
        if (startDateStr && totalOrders > 0) {
          const start = moment(startDateStr);
          const end = moment();
          const days = end.diff(start, 'days');
          if (days > 0) {
            const avgPerDay = totalOrders / days;
            const expectedOrders = Math.ceil(avgPerDay * (this.state.safeWeek * 7));
            return diff - expectedOrders;
          }
        }
        return diff;
      };
      sorted.sort((a, b) => getChenhSafe(a) - getChenhSafe(b));
    } else if (sortType === 'totalOrdersSku' || sortType === 'totalPendingSku') {
      // Gộp theo sku_code
      const skuMap = {};
      sorted.forEach(p => {
        const sku = p.sku_code;
        if (!skuMap[sku]) skuMap[sku] = { totalOrders: 0, totalPending: 0 };
        skuMap[sku].totalOrders += p.stats?.total_listings || 0;
        skuMap[sku].totalPending += (p.stats?.processing_sale || 0) + (p.stats?.processing_fulfill || 0);
      });
      // Sắp xếp sku theo tổng
      let skuOrder = Object.entries(skuMap);
      if (sortType === 'totalOrdersSku') {
        skuOrder.sort((a, b) => b[1].totalOrders - a[1].totalOrders);
      } else {
        skuOrder.sort((a, b) => b[1].totalPending - a[1].totalPending);
      }
      // Sắp xếp lại sản phẩm theo thứ tự sku
      const skuOrderArr = skuOrder.map(([sku]) => sku);
      sorted.sort((a, b) => {
        const idxA = skuOrderArr.indexOf(a.sku_code);
        const idxB = skuOrderArr.indexOf(b.sku_code);
        return idxA - idxB;
      });
    } else if (sortType === 'sku') {
      // Sắp xếp theo sku_code, rồi theo size (M, L, XL, XXL)
      const sizeOrder = { 'M': 1, 'L': 2, 'XL': 3, 'XXL': 4 };
      sorted.sort((a, b) => {
        const skuA = a.sku_code || '';
        const skuB = b.sku_code || '';
        if (skuA === skuB) {
          const sizeA = sizeOrder[a.size] || 99;
          const sizeB = sizeOrder[b.size] || 99;
          return sizeA - sizeB;
        }
        return skuA.localeCompare(skuB);
      });
    }
    this.setState({ sortedProducts: sorted });
  };

  formatDate = (dateString) => {
    if (!dateString) return '-';
    return moment(dateString).format('DD/MM/YYYY HH:mm');
  };

  handleExportGGSheet = async () => {
    const { statsDateFilter, safeWeek, selectedSupplier, selectedStatus, sortType } = this.state;
    const export_supplier = selectedSupplier || 'RESIN_HOAI_DUC';
    const safe_week = safeWeek;
    this.setState({ exporting: true });
    try {
      // Build query string
      const queryParams = new URLSearchParams({
        export_ggsheet: true,
        export_supplier,
        safe_week,
        export_sort: sortType,
        stats_display: this.state.statsDisplay,
        stats_start_date: this.getStatsStartDate(statsDateFilter),
        stats_end_date: this.getStatsEndDate(statsDateFilter),
        has_orders: this.state.hasOrders,
        has_pending_orders: this.state.hasPendingOrders,
        suppliers: selectedSupplier === 'ALL' ? undefined : selectedSupplier,
        status: selectedStatus === 'ALL' ? undefined : selectedStatus
      });

      // Remove undefined values
      for (const [key, value] of queryParams.entries()) {
        if (value === 'undefined' || value === 'null') {
          queryParams.delete(key);
        }
      }

      const queryString = queryParams.toString();
      console.log('Export URL:', `${getApiUrl()}/api/ses/product?${queryString}`);

      // Get token from localStorage
      const token = getToken();
      if (!token) {
        throw new Error('No authentication token found');
      }

      const res = await fetch(`${getApiUrl()}/api/ses/product?${queryString}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      console.log('DEBUG res', data);
      const sheetUrl = data?.data?.export?.sheetUrl;
      if (sheetUrl) {
        window.open(sheetUrl, '_blank');
      } else {
        alert('Không nhận được sheetUrl từ server!');
      }
    } catch (err) {
      console.error('Export error:', err);
      alert('Export Google Sheet thất bại!');
    }
    this.setState({ exporting: false });
  };

  getExportQuery = () => {
    // Build the same query as loadProducts, but only with relevant params
    const { currentPage, itemsPerPage, sortBy, sortOrder, keyword, statsDisplay, statsDateFilter, hasOrders, hasPendingOrders, selectedSupplier, selectedStatus, safeWeek, sortType } = this.state;
    const query = {
      currentPage,
      itemsPerPage,
      sortBy,
      sortOrder,
      keyword,
      stats_display: statsDisplay,
      stats_start_date: this.getStatsStartDate(statsDateFilter),
      stats_end_date: this.getStatsEndDate(statsDateFilter),
      has_orders: hasOrders,
      has_pending_orders: hasPendingOrders,
      suppliers: selectedSupplier === 'ALL' ? undefined : selectedSupplier,
      status: selectedStatus === 'ALL' ? undefined : selectedStatus,
      safe_week: safeWeek,
      export_sort: sortType
    };
    return query;
  };

  render() {
    const { totalCount } = this.props;
    const { 
      loading, 
      currentPage, 
      itemsPerPage, 
      sortBy, 
      sortOrder, 
      keyword, 
      columnVisibility, 
      showModal, 
      selectedProductId, 
      mode, 
      currentProduct,
      showQuantityChangeModal,
      selectedProductCode,
      selectedProductName,
      sortedProducts,
      showIframeModal,
      iframeUrl,
      iframeTitle,
      showCloneModal,
      productToClone,
      showImageModal,
      imageToShow,
      showConfigModal,
      statsDisplay,
      statsDateFilter,
      stats,
      hasOrders,
      hasPendingOrders,
      sortType,
      safeWeek,
      selectedSupplier,
      selectedStatus,
      exporting,
      stickHeader
    } = this.state;
    const { user } = this.props;
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const showingCount = sortedProducts.length;

    console.log("SESProductList currentProduct", this.state.currentProduct);

    console.log("RENDER sortBy orderBy", sortBy, sortOrder);

    const isFulfill = window.location.pathname.includes('/fulfill/');

    // Tính toán các biến tổng cho dòng summary
    let totalCurrentQty = 0, totalOrders = 0, totalPending = 0, totalSale = 0, totalFulfill = 0, totalShipped = 0, totalDiff = 0, totalExpected = 0, totalChenhSafe = 0, totalChenhSafeThieu = 0;
    const filterStartDateStr = this.getStatsStartDate(this.state.statsDateFilter);
    const filterStartDate = filterStartDateStr ? new Date(filterStartDateStr) : null;
    const today = new Date();
    const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    this.state.sortedProducts.forEach(product => {
      const currentQty = product.current_qty || 0;
      const orders = product.stats?.total_listings || 0;
      const sale = product.stats?.processing_sale || 0;
      const fulfill = product.stats?.processing_fulfill || 0;
      const pending = sale + fulfill;
      const shipped = product.stats?.shipped || 0;
      const diff = currentQty - pending;
      let expectedOrders = '-';
      let chenhSafe = '-';
      if (filterStartDate && !isNaN(filterStartDate.getTime()) && orders > 0) {
        const start = moment(filterStartDate);
        const end = moment(); // hôm nay
        console.l
        const days = end.diff(start, 'days');
        if (days > 0) {
          const avgPerDay = orders / days * 1.0;
          expectedOrders = Math.ceil(avgPerDay * (safeWeek * 7));
          chenhSafe = diff - expectedOrders;
        } else {
          expectedOrders = 0;
          chenhSafe = diff;
        }
      }
      if (chenhSafe !== '-' && chenhSafe < 0) {
        totalChenhSafeThieu += Math.abs(chenhSafe);
      }
      totalCurrentQty += currentQty;
      totalOrders += orders;
      totalSale += sale;
      totalFulfill += fulfill;
      totalPending += pending;
      totalShipped += shipped;
      totalDiff += diff;
      totalExpected += expectedOrders;
      totalChenhSafe += chenhSafe;
    });

    const { isRnd, isWarehouse, isSale } = this.getRouteType();
    
    console.log('Render state:', { showModal, currentProduct, mode, isRnd });

    return (
      <Container fluid>
        {!isRnd && false && (
          <Row style={{ marginBottom: -40 }}>
            <Col md="2">
              <Card className="text-center">
                <Card.Body>
                  <Card.Title>Tổng tồn kho hiện tại</Card.Title>
                  <Card.Text className="display-6" style={{ color: '#28a745', fontWeight: 'bold' }}>
                    {this.state.sortedProducts.reduce((sum, product) => sum + (product.current_qty || 0), 0).toLocaleString()}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md="2">
              <Card className="text-center">
                <Card.Body>
                  <Card.Title>Tổng đơn nợ</Card.Title>
                  <Card.Text className="display-6" style={{ color: '#dc3545', fontWeight: 'bold' }}>
                    {this.state.sortedProducts.reduce((sum, product) => {
                      const saleProcessing = product.stats?.processing_sale || 0;
                      const fulfillProcessing = product.stats?.processing_fulfill || 0;
                      return sum + saleProcessing + fulfillProcessing;
                    }, 0).toLocaleString()}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md="2">
              <Card className="text-center">
                <Card.Body>
                  <Card.Title>Tổng đã ship</Card.Title>
                  <Card.Text className="display-6" style={{ color: '#0d6efd', fontWeight: 'bold' }}>
                    {this.state.sortedProducts.reduce((sum, product) => sum + (product.stats?.shipped || 0), 0).toLocaleString()}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
        <h2 className="text-center mb-4">
          {isRnd
            ? getTranslate(LANGUAGE_KEYS.TEXT_RND_PRODUCT)
            : isSale
            ? getTranslate(LANGUAGE_KEYS.TEXT_SALE_STATS)
            : getTranslate(LANGUAGE_KEYS.TEXT_INVENTORY)}
        </h2>
        
        {(isSale || isWarehouse) && this.state.statsDisplay && (
          <>
            {/* Dòng 1 */}
            <Row className="mb-2 align-items-center">
              {!isWarehouse && (
                <Col md="auto">
                  <Form.Select
                    value={this.state.statsDateFilter}
                    onChange={e => {
                      localStorage.setItem('sesProductStatsDateFilter', e.target.value);
                      this.setState({ statsDateFilter: e.target.value }, this.loadProducts);
                    }}
                    style={{ width: 140 }}
                    className="me-2"
                  >
                    <option value="today">Hôm nay</option>
                    <option value="yesterday">Hôm qua</option>
                    <option value="this_week">Tuần này</option>
                    <option value="last_week">Tuần trước</option>
                    <option value="this_month">Tháng này</option>
                    <option value="last_month">Tháng trước</option>
                    <option value="last_7_days">7 ngày qua</option>
                    <option value="last_14_days">14 ngày qua</option>
                    <option value="last_30_days">30 ngày qua</option>
                    <option value="all">Tất cả</option>
                  </Form.Select>
                </Col>
              )}
              <Col md="auto">
                <Form.Select
                  value={this.state.selectedSupplier}
                  onChange={e => {
                    localStorage.setItem('sesProductSelectedSupplier', e.target.value);
                    this.setState({ selectedSupplier: e.target.value }, this.loadProducts);
                  }}
                  style={{ width: 180 }}
                  className="me-2"
                >
                  {this.SUPPLIERS.map(supplier => (
                    <option key={supplier.value} value={supplier.value}>{supplier.label}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col md="auto">
                <Form.Select
                  value={this.state.selectedStatus}
                  onChange={e => {
                    localStorage.setItem('sesProductSelectedStatus', e.target.value);
                    this.setState({ selectedStatus: e.target.value }, this.loadProducts);
                  }}
                  style={{ width: 150 }}
                  className="me-2"
                >
                  {this.STATUS_OPTIONS.map(status => (
                    <option key={status.value} value={status.value}>{status.label}</option>
                  ))}
                </Form.Select>
              </Col>
              {!isSale && (
                <Col md="auto">
                  <Form.Check
                    type="checkbox"
                    id="has-orders-checkbox"
                    label="Có đơn"
                    checked={this.state.hasOrders}
                    onChange={e => {
                      localStorage.setItem('sesProductHasOrders', e.target.checked);
                      this.setState({ hasOrders: e.target.checked }, () => {
                        this.loadProducts();
                      });
                    }}
                    className="me-2"
                  />
                </Col>
              )}
              {!isSale && (
                <Col md="auto">
                  <Form.Check
                    type="checkbox"
                    id="has-pending-orders-checkbox"
                    label="Có đơn nợ"
                    checked={this.state.hasPendingOrders}
                    onChange={e => {
                      localStorage.setItem('sesProductHasPendingOrders', e.target.checked);
                      this.setState({ hasPendingOrders: e.target.checked }, () => {
                        this.loadProducts();
                      });
                    }}
                    className="me-2"
                  />
                </Col>
              )}
              <Col style={{ minWidth: 300, maxWidth: 400 }}>
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder={getTranslate(LANGUAGE_KEYS.TEXT_SEARCH) + '...'}
                    value={this.state.keyword}
                    onChange={this.handleSearch}
                    style={{ minWidth: 300 }}
                  />
                </InputGroup>
              </Col>
              <Col md="auto">
                <Form.Select
                  value={this.state.sortType}
                  onChange={e => {
                    localStorage.setItem('sesProductSortType', e.target.value);
                    this.setState({ sortType: e.target.value }, this.sortStatsProducts);
                  }}
                  style={{ width: 200 }}
                >
                  <option value="totalOrders">Tổng đơn (giảm dần)</option>
                  <option value="totalOrdersSku">Tổng đơn SKU gộp (giảm dần)</option>
                  <option value="totalPending">Tổng đơn nợ (giảm dần)</option>
                  <option value="totalPendingSku">Tổng đơn nợ SKU (giảm dần)</option>
                  {!isSale && (
                    <>
                      <option value="diff">Chênh kho (tăng dần)</option>
                      <option value="chenhSafe">Chênh dự kiến (tăng dần)</option>
                    </>
                  )}
                  <option value="sku">SKU</option>
                </Form.Select>
              </Col>
              {!isSale && (
                <Col md="auto">
                  <Form.Select
                    value={this.state.safeWeek}
                    onChange={e => {
                      localStorage.setItem('sesProductSafeWeek', e.target.value);
                      this.setState({ safeWeek: parseInt(e.target.value) });
                    }}
                    style={{ width: 180 }}
                    className="me-2"
                  >
                    {[...Array(8)].map((_, i) => (
                      <option key={i+1} value={i+1}>{`Dư ${i+1} tuần`}</option>
                    ))}
                  </Form.Select>
                </Col>
              )}
              {(() => {
                console.log('Debug Export Google Sheet button conditions:', {
                  statsDisplay: statsDisplay,
                  isRnd: isRnd,
                  user: user,
                  userGroups: user?.groups,
                  hasRootAccess: user?.groups?.includes(USER_GROUPS.ROOT)
                });
                return statsDisplay && (isSale || isWarehouse) && user && (user.groups || []).includes(USER_GROUPS.ROOT) && (
                  <Col md="auto">
                    <Button
                      variant="danger"
                      onClick={this.handleExportGGSheet}
                      disabled={exporting}
                    >
                      {exporting ? <Spinner size="sm" animation="border" className="me-2" /> : null}
                      Export Google Sheet
                    </Button>
                  </Col>
                );
              })()}
              <Col md="auto">
                <Button 
                  variant="secondary" 
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                  {this.state.stickHeader && (
                    <span className="ms-2 badge bg-success" title="Sticky header enabled">
                      📌
                    </span>
                  )}
                </Button>
              </Col>
            </Row>
            {/* Dòng 2 */}
            <Row className="mb-2 align-items-center">
              {isSale && (
                <Col md={12} className="mb-2">
                  <div style={{ 
                    fontSize: 14, 
                    color: '#666', 
                    fontStyle: 'italic',
                    textAlign: 'center',
                    padding: '8px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '4px',
                    border: '1px solid #dee2e6'
                  }}>
                    Thống kê từ {this.getStatsStartDate(this.state.statsDateFilter)} đến {this.getStatsEndDate(this.state.statsDateFilter)}
                  </div>
                </Col>
              )}
              <Col md={8}>
                {(isSale || isWarehouse) && this.state.statsDisplay && this.state.hasOrders && this.state.sortedProducts && this.state.sortedProducts.length > 0 && (() => {
                  let totalOrders = 0;
                  let totalPending = 0;
                  let saleProcessing = 0;
                  let fulfillProcessing = 0;
                  let shipped = 0;
                  let totalCurrentQty = 0;
                  let totalSurplus = 0; // Thừa kho
                  let totalDeficit = 0; // Thiếu kho
                  let totalCancelOrders = 0; // Tổng đơn huỷ
                  this.state.sortedProducts.forEach(product => {
                    totalOrders += product.stats?.total_listings || 0;
                    const cancelOrders = product.stats?.cancelOrders || 0;
                    totalCancelOrders += cancelOrders;
                    saleProcessing += product.stats?.processing_sale || 0;
                    fulfillProcessing += product.stats?.processing_fulfill || 0;
                    shipped += product.stats?.shipped || 0;
                    totalCurrentQty += product.current_qty || 0;
                    const diff = (product.current_qty || 0) - ((product.stats?.processing_sale || 0) + (product.stats?.processing_fulfill || 0));
                    if (diff > 0) totalSurplus += diff;
                    if (diff < 0) totalDeficit += Math.abs(diff);
                  });
                  totalPending = saleProcessing + fulfillProcessing;
                  return (
                    <div style={{ fontWeight: 500, fontSize: 16, display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                      {totalOrders !== 0 && (
                        <span>
                          Tổng đơn: <span style={{ color: '#28a745', fontWeight: 700 }}>{totalOrders}</span>
                        </span>
                      )}
                      {totalCancelOrders !== 0 && (
                        <span>
                          Đơn huỷ: <span style={{ color: '#6c757d', fontWeight: 700 }}>{totalCancelOrders}</span>
                        </span>
                      )}
                      {totalPending !== 0 && (
                        <span>
                          Tổng đơn nợ: <span style={{ color: '#dc3545' }}>{totalPending}</span>
                        </span>
                      )}
                      {saleProcessing !== 0 && (
                        <span>
                          Sale xử lý: <span>{saleProcessing}</span>
                        </span>
                      )}
                      {fulfillProcessing !== 0 && (
                        <span>
                          Fulfill xử lý: <span>{fulfillProcessing}</span>
                        </span>
                      )}
                      {shipped !== 0 && (
                        <span>
                          Đã ship: <span style={{ color: '#28a745' }}>{shipped}</span>
                        </span>
                      )}
                      {isSale && totalCurrentQty !== 0 && (
                        <span>
                          Tổng tồn kho: <span style={{ color: '#007bff', fontWeight: 700 }}>{totalCurrentQty}</span>
                        </span>
                      )}
                      {!isSale && totalSurplus !== 0 && (
                        <span>
                          Thừa kho: <span style={{ color: '#28a745' }}>{totalSurplus}</span>
                        </span>
                      )}
                      {!isSale && totalDeficit !== 0 && (
                        <span>
                          Thiếu kho: <span style={{ color: '#dc3545' }}>{totalDeficit}</span>
                        </span>
                      )}
                      {!isSale && totalExpected !== 0 && (
                        <span>
                          Dự kiến đơn {safeWeek} tuần: <span style={{ color: '#007bff', fontWeight: 700 }}>{totalExpected}</span>
                        </span>
                      )}
                      {!isSale && totalChenhSafeThieu > 0 && (
                        <span>
                          Tổng Dự kiến thiếu: <span style={{ color: '#dc3545', fontWeight: 700 }}>{totalChenhSafeThieu}</span>
                        </span>
                      )}
                    </div>
                  );
                })()}
              </Col>
              <Col md={4} className="text-end">
                <span>
                  Tổng số sản phẩm: <strong>{totalCount}</strong> &nbsp; Đang hiển thị: <strong>{showingCount}</strong>
                </span>
                <Form.Select
                  value={itemsPerPage}
                  onChange={this.handleItemsPerPageChange}
                  style={{ width: 'auto', display: 'inline-block', marginLeft: 16 }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={200}>200</option>
                  <option value={500}>500</option>
                </Form.Select>
              </Col>
            </Row>
          </>
        )}

        {isRnd && (
          <>
            <Row className="mb-3">
              <Col md={3}>
                <Form.Select
                  value={this.state.selectedSupplier}
                  onChange={e => {
                    localStorage.setItem('sesProductSelectedSupplier', e.target.value);
                    this.setState({ selectedSupplier: e.target.value }, this.loadProducts);
                  }}
                  style={{ width: '100%' }}
                  className="me-2"
                >
                  {this.SUPPLIERS.map(supplier => (
                    <option key={supplier.value} value={supplier.value}>{supplier.label}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col md={3}>
                <Form.Select
                  value={this.state.selectedStatus}
                  onChange={e => {
                    localStorage.setItem('sesProductSelectedStatus', e.target.value);
                    this.setState({ selectedStatus: e.target.value }, this.loadProducts);
                  }}
                  style={{ width: '100%' }}
                  className="me-2"
                >
                  {this.STATUS_OPTIONS.map(status => (
                    <option key={status.value} value={status.value}>{status.label}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col md={3}>
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder={getTranslate(LANGUAGE_KEYS.TEXT_SEARCH) + '...'}
                    value={this.state.keyword}
                    onChange={this.handleSearch}
                  />
                </InputGroup>
              </Col>
              <Col className="text-end">
                <Button 
                  variant="primary" 
                  onClick={() => {
                    console.log('Add New Product button clicked');
                    this.handleCreate();
                  }}
                >
                  <i className="fas fa-plus"></i> {getTranslate(LANGUAGE_KEYS.TEXT_ADD_NEW_PRODUCT)}
                </Button>
                <Button 
                  variant="secondary" 
                  className="ms-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                  {this.state.stickHeader && (
                    <span className="ms-2 badge bg-success" title="Sticky header enabled">
                      📌
                    </span>
                  )}
                </Button>
                <Form.Select
                  value={itemsPerPage}
                  onChange={this.handleItemsPerPageChange}
                  style={{ width: 'auto', display: 'inline-block', marginLeft: 16, maxWidth: 120 }}
                  className="ms-2 d-inline-block"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={200}>200</option>
                  <option value={500}>500</option>
                </Form.Select>
              </Col>
            </Row>
            <Row className="mb-2 align-items-center">
              <Col md={8}>
                {/* Có thể thêm thông tin thống kê khác ở đây nếu cần */}
              </Col>
              <Col md={4} className="text-end">
                <span>
                  Tổng số sản phẩm: <strong>{totalCount}</strong> &nbsp; Đang hiển thị: <strong>{showingCount}</strong>
                </span>
              </Col>
            </Row>
          </>
        )}

        <Table striped bordered hover responsive className={this.state.stickHeader ? 'table-sticky-header' : ''}>
          <thead>
            <tr>
              <th style={{ width: 60, textAlign: 'center' }}>STT</th>
              {this.state.statsDisplay ? (
                <>
                  <th>{getTranslate(LANGUAGE_KEYS.TEXT_IMAGE)}</th>
                  <th>{getTranslate(LANGUAGE_KEYS.TEXT_SKU_CODE)}</th>
                  <th>{getTranslate(LANGUAGE_KEYS.TEXT_SIZE)}</th>
                  <th>{getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_NAME)}</th>
                  <th>{getTranslate(LANGUAGE_KEYS.TEXT_CURRENT_QUANTITY)}</th>
                  <th>{getTranslate(LANGUAGE_KEYS.TEXT_CURRENT_CELL_CODE) || 'Location'}</th>
                  <th>Trạng thái</th>
                  <th>Tổng đơn</th>
                  <th>Đơn huỷ</th>
                  <th>Tổng đơn nợ</th>
                  <th>Sale xử lý</th>
                  <th>Fulfill xử lý</th>
                  <th>Đã ship</th>
                  {!isSale && <th>Chênh kho</th>}
                  {this.state.statsDateFilter === 'all' && (
                    <>
                      <th>Dự kiến đơn {safeWeek} tuần</th>
                      <th>Chênh dự kiến</th>
                    </>
                  )}
                </>
              ) : (
                <>
                  {columnVisibility.image && <th>{getTranslate(LANGUAGE_KEYS.TEXT_IMAGE)}</th>}
                  {columnVisibility.skuCode && (
                    <th onClick={() => this.handleSort('sku_code')} style={{ cursor: 'pointer' }}>
                      {getTranslate(LANGUAGE_KEYS.TEXT_SKU_CODE)} {sortBy === 'sku_code' && (sortOrder < 0 ? '↓' : '↑')}
                    </th>
                  )}
                  {columnVisibility.size && (
                    <th onClick={() => this.handleSort('size')} style={{ cursor: 'pointer' }}>
                      {getTranslate(LANGUAGE_KEYS.TEXT_SIZE)} {sortBy === 'size' && (sortOrder < 0 ? '↓' : '↑')}
                    </th>
                  )}
                  {columnVisibility.style && (
                    <th onClick={() => this.handleSort('style')} style={{ cursor: 'pointer' }}>
                      {getTranslate(LANGUAGE_KEYS.TEXT_STYLE)} {sortBy === 'style' && (sortOrder < 0 ? '↓' : '↑')}
                    </th>
                  )}
                  {columnVisibility.productName && (
                    <th onClick={() => this.handleSort('product_name')} style={{ cursor: 'pointer' }}>
                      {getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_NAME)} {sortBy === 'product_name' && (sortOrder < 0 ? '↓' : '↑')}
                    </th>
                  )}
                  {columnVisibility.basePrice && (
                    <th onClick={() => this.handleSort('base_price_vnd')} style={{ cursor: 'pointer' }}>
                      {getTranslate(LANGUAGE_KEYS.TEXT_BASE_PRICE)} {sortBy === 'base_price_vnd' && (sortOrder < 0 ? '↓' : '↑')}
                    </th>
                  )}
                  {columnVisibility.currentQuantity && (
                    <th onClick={() => this.handleSort('current_qty')} style={{ cursor: 'pointer' }}>
                      {getTranslate(LANGUAGE_KEYS.TEXT_CURRENT_QUANTITY)} {sortBy === 'current_qty' && (sortOrder < 0 ? '↓' : '↑')}
                    </th>
                  )}
                  {columnVisibility.currentCellCode && (
                    <th onClick={() => this.handleSort('current_cell_code')} style={{ cursor: 'pointer' }}>
                      {getTranslate(LANGUAGE_KEYS.TEXT_CURRENT_CELL_CODE) || 'Location'} {sortBy === 'current_cell_code' && (sortOrder < 0 ? '↓' : '↑')}
                    </th>
                  )}
                  {columnVisibility.status && (
                    <th onClick={() => this.handleSort('status')} style={{ cursor: 'pointer' }}>
                      Trạng thái {sortBy === 'status' && (sortOrder < 0 ? '↓' : '↑')}
                    </th>
                  )}
                  {isRnd && <th>Nhà cung cấp</th>}
                  {columnVisibility.material && <th>{getTranslate(LANGUAGE_KEYS.TEXT_MATERIAL)}</th>}
                  {columnVisibility.color && <th>{getTranslate(LANGUAGE_KEYS.TEXT_COLOR)}</th>}
                  {columnVisibility.dimensions && <th>{getTranslate(LANGUAGE_KEYS.TEXT_DIMENSIONS)}</th>}
                  {columnVisibility.weight && <th>{getTranslate(LANGUAGE_KEYS.TEXT_WEIGHT)}</th>}
                  {columnVisibility.lastUpdate && (
                    <th onClick={() => this.handleSort('updated_at')} style={{ cursor: 'pointer' }}>
                      {getTranslate(LANGUAGE_KEYS.TEXT_LAST_UPDATE)} {sortBy === 'updated_at' && (sortOrder < 0 ? '↓' : '↑')}
                    </th>
                  )}
                  {columnVisibility.action && <th>{getTranslate(LANGUAGE_KEYS.TEXT_ACTIONS)}</th>}
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} className="text-center"><Spinner animation="border" size="sm" /></td></tr>
            ) : sortedProducts.length === 0 ? (
              <tr><td colSpan={6} className="text-center">No products</td></tr>
            ) : this.state.statsDisplay ? (
              sortedProducts.map((product, idx) => {
                const totalOrders = product.stats?.total_listings || 0;
                const cancelOrders = product.stats?.cancelOrders || 0;
                const saleProcessing = product.stats?.processing_sale || 0;
                const fulfillProcessing = product.stats?.processing_fulfill || 0;
                const totalPending = saleProcessing + fulfillProcessing;
                const shipped = product.stats?.shipped || 0;
                const diff = (product.current_qty || 0) - totalPending;
                // Tính dự kiến đơn và chênh safe dựa vào filter date
                let expectedOrders = '-';
                let chenhSafe = '-';
                if (filterStartDate && !isNaN(filterStartDate.getTime()) && totalOrders > 0) {
                  const start = moment(filterStartDate);
                  const end = moment(); // hôm nay
                  const days = end.diff(start, 'days');
                  if (days > 0) {
                    const avgPerDay = totalOrders / days;
                    expectedOrders = Math.ceil(avgPerDay * (safeWeek * 7));
                    chenhSafe = diff - expectedOrders;
                  } else {
                    expectedOrders = 0;
                    chenhSafe = diff;
                  }
                }
                return (
                  <tr key={product._id}>
                    <td style={{ textAlign: 'center' }}>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                    <td style={{ width: '100px' }}>
                      {product.images[0] ? (
                        <Image
                          src={product.images[0].image_link}
                          alt={product.product_name}
                          thumbnail
                          style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'contain', cursor: 'pointer' }}
                          onClick={() => this.handleShowImage(product.images[0].image_link)}
                          title="Xem ảnh lớn"
                        />
                      ) : (
                        <div className="text-center text-muted">No image</div>
                      )}
                    </td>
                    <td>{product.sku_code}</td>
                    <td>{product.size}</td>
                    <td>{product.product_name}</td>
                    <td>
                      {product.current_qty || 0}
                      <Button
                        variant="link"
                        size="sm"
                        className="ms-2 p-0"
                        onClick={() => this.handleViewQuantityChanges(product)}
                        title="View Quantity Changes"
                      >
                        <FaHistory />
                      </Button>
                    </td>
                    <td>{product.current_cell_code || '-'}</td>
                    <td>
                      <Badge 
                        bg={
                          product.status === 'ACTIVE' ? 'success' :
                          product.status === 'DEACTIVE' ? 'secondary' :
                          product.status === 'RND' ? 'info' :
                          product.status === 'CANCEL' ? 'danger' : 'light'
                        }
                      >
                        {product.status || 'ACTIVE'}
                      </Badge>
                    </td>
                    {isRnd && (
                      <td>{(product.suppliers && product.suppliers.length > 0) ? product.suppliers[0] : '-'}</td>
                    )}
                    <td>{totalOrders !== 0 ? <span style={{ fontWeight: 700 }}>{totalOrders}</span> : ''}</td>
                    <td>{cancelOrders !== 0 ? <span style={{ color: '#6c757d' }}>{cancelOrders}</span> : ''}</td>
                    <td>{totalPending !== 0 ? <span style={{ color: '#dc3545' }}>{totalPending}</span> : ''}</td>
                    <td>{saleProcessing !== 0 ? saleProcessing : ''}</td>
                    <td>{fulfillProcessing !== 0 ? fulfillProcessing : ''}</td>
                                        <td>{shipped !== 0 ? <span style={{ color: '#28a745' }}>{shipped}</span> : ''}</td>
                    {!isSale && (
                      <td>
                        {diff !== 0 ? (
                          <span style={{ color: diff >= 0 ? '#28a745' : '#dc3545' }}>{diff}</span>
                        ) : ''}
                      </td>
                    )}
                      {this.state.statsDateFilter === 'all' && (
                        <>
                          <td>
                            {expectedOrders !== '-' ? expectedOrders : '-'}
                          </td>
                          <td>
                            {chenhSafe !== '-' ? (
                              <span style={{ color: chenhSafe >= 0 ? '#28a745' : '#dc3545' }}>{chenhSafe}</span>
                            ) : '-'}
                          </td>
                        </>
                      )}
                  </tr>
                );
              })
            ) : (
              sortedProducts.map((product, idx) => (
                <tr key={product._id}>
                  <td style={{ textAlign: 'center' }}>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                  {columnVisibility.image && (
                    <td style={{ width: '100px' }}>
                      {product.images[0] ? (
                        <Image
                          src={product.images[0].image_link}
                          alt={product.product_name}
                          thumbnail
                          style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'contain', cursor: 'pointer' }}
                          onClick={() => this.handleShowImage(product.images[0].image_link)}
                          title="Xem ảnh lớn"
                        />
                      ) : (
                        <div className="text-center text-muted">No image</div>
                      )}
                    </td>
                  )}
                  {columnVisibility.skuCode && <td>{product.sku_code}</td>}
                  {columnVisibility.size && <td>{product.size}</td>}
                  {columnVisibility.style && <td>{product.style}</td>}
                  {columnVisibility.productName && <td>{product.product_name}</td>}
                  {columnVisibility.basePrice && <td>{product.base_price_vnd?.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })}</td>}
                  {columnVisibility.currentQuantity && (
                    <td>
                      {product.current_qty || 0}
                      <Button
                        variant="link"
                        size="sm"
                        className="ms-2 p-0"
                        onClick={() => this.handleViewQuantityChanges(product)}
                        title="View Quantity Changes"
                      >
                        <FaHistory />
                      </Button>
                    </td>
                  )}
                  {columnVisibility.currentCellCode && <td>{product.current_cell_code || '-'}</td>}
                  {columnVisibility.status && (
                    <td>
                      <Badge 
                        bg={
                          product.status === 'ACTIVE' ? 'success' :
                          product.status === 'DEACTIVE' ? 'secondary' :
                          product.status === 'RND' ? 'info' :
                          product.status === 'CANCEL' ? 'danger' : 'light'
                        }
                      >
                        {product.status || 'ACTIVE'}
                      </Badge>
                    </td>
                  )}
                  {isRnd && (
                    <td>{(product.suppliers && product.suppliers.length > 0) ? product.suppliers[0] : '-'}</td>
                  )}
                  {columnVisibility.material && <td>{product.properties?.material}</td>}
                  {columnVisibility.color && <td>{product.properties?.color}</td>}
                  {columnVisibility.dimensions && (
                    <td>
                      {product.properties?.length_mm && `${product.properties.length_mm}mm`} x
                      {product.properties?.width_mm && `${product.properties.width_mm}mm`} x
                      {product.properties?.height_mm && `${product.properties.height_mm}mm`}
                    </td>
                  )}
                  {columnVisibility.weight && <td>{product.properties?.weight_g}g</td>}
                  {columnVisibility.lastUpdate && (
                    <td>
                      {product.updated_at ? this.formatDate(product.updated_at) : '-'}
                    </td>
                  )}
                  {columnVisibility.action && (
                    <td>
                      <Button 
                        variant="info" 
                        size="sm" 
                        className="me-2"
                        onClick={() => this.handleView(product)}
                        title={getTranslate(LANGUAGE_KEYS.TEXT_VIEW)}
                      >
                        <i className="fas fa-eye"></i> {getTranslate(LANGUAGE_KEYS.TEXT_VIEW)}
                      </Button>
                      <Button 
                        variant="primary" 
                        size="sm" 
                        className="me-2"
                        onClick={() => this.handleEdit(product)}
                        title={getTranslate(LANGUAGE_KEYS.TEXT_EDIT)}
                      >
                        <FaEdit /> {getTranslate(LANGUAGE_KEYS.TEXT_EDIT)}
                      </Button>
                      <Button
                        variant="secondary" 
                        size="sm"
                        className="me-2"
                        onClick={() => this.handleViewVersions(product)}
                        title={getTranslate(LANGUAGE_KEYS.TEXT_VERSIONS)}
                      >
                        <i className="fas fa-code-branch"></i> {getTranslate(LANGUAGE_KEYS.TEXT_VERSIONS)}
                      </Button>
                      <Button
                        variant="info" 
                        size="sm"
                        className="me-2"
                        onClick={() => this.handleClone(product)}
                        title={getTranslate(LANGUAGE_KEYS.TEXT_CLONE)}
                      >
                        <FaCopy /> {getTranslate(LANGUAGE_KEYS.TEXT_CLONE)}
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => this.handleDelete(product)}
                        title={getTranslate(LANGUAGE_KEYS.TEXT_DELETE)}
                      >
                        <FaTrash /> {getTranslate(LANGUAGE_KEYS.TEXT_DELETE)}
                      </Button>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </Table>

        <Row className="mt-3 align-items-center">

          <Col md={12}>
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mb-5">
                <Button
                  variant="outline-primary"
                  className="me-2"
                  disabled={currentPage === 1}
                  onClick={() => this.handlePageChange(currentPage - 1)}
                >
                  {getTranslate(LANGUAGE_KEYS.TEXT_PREVIOUS)}
                </Button>
                <span className="mx-2 my-auto">
                  {getTranslate(LANGUAGE_KEYS.TEXT_PAGE)} {currentPage} / {totalPages}
                </span>
                <Button
                  variant="outline-primary"
                  className="ms-2"
                  disabled={currentPage === totalPages}
                  onClick={() => this.handlePageChange(currentPage + 1)}
                >
                  {getTranslate(LANGUAGE_KEYS.TEXT_NEXT)}
                </Button>
              </div>
            )}
          </Col>
        </Row>

        <CloneModal
          show={showCloneModal}
          onHide={() => this.setState({ 
            showCloneModal: false,
            productToClone: null
          })}
          product={productToClone}
          onSubmit={this.handleCloneSubmit}
        />

        <ViewModal 
          show={showModal} 
          onClose={() => this.setState({ showModal: false, currentProduct: null })} 
          currentProduct={currentProduct}
          mode={mode}
        />

        <QuantityChangeModal
          show={showQuantityChangeModal}
          onHide={() => this.setState({ 
            showQuantityChangeModal: false, 
            selectedProductCode: null,
            selectedProductName: null 
          })}
          productCode={selectedProductCode}
          productName={selectedProductName}
          showCalculateButton={!this.getRouteType().isRnd}
        />

        <IframeModal
          show={showIframeModal}
          showSidebar={false}
          onHide={() => this.setState({ 
            showIframeModal: false,
            iframeUrl: null,
            iframeTitle: ''
          })}
          url={iframeUrl}
          title={iframeTitle}
        />

        {showImageModal && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: 'rgba(0,0,0,0.7)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 20000
            }}
            onClick={this.handleCloseImage}
          >
            <div style={{ position: 'relative', maxWidth: '90vw', maxHeight: '90vh' }}>
              <img
                src={imageToShow}
                alt="Product Large"
                style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: 8, boxShadow: '0 2px 16px rgba(0,0,0,0.5)' }}
                onClick={e => e.stopPropagation()}
              />
              <button
                onClick={this.handleCloseImage}
                style={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  background: '#fff',
                  border: 'none',
                  borderRadius: '50%',
                  width: 32,
                  height: 32,
                  fontSize: 20,
                  cursor: 'pointer',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.2)'
                }}
                title="Đóng"
              >
                ×
              </button>
            </div>
          </div>
        )}

        <div style={{
          position: 'fixed',
          right: '20px',
          bottom: '20px',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          gap: '10px'
        }}>
          <Button
            variant="primary"
            size="sm"
            style={{
              width: '32px',
              height: '32px',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              backgroundColor: '#0d6efd',
              border: 'none',
              boxShadow: '0 2px 8px rgba(13, 110, 253, 0.15)',
              color: '#fff',
              fontSize: 18,
              transition: 'all 0.2s'
            }}
            onClick={() => {
              const panel = document.querySelector('.main-panel');
              if (panel) {
                panel.scrollTo({ top: 0, behavior: 'smooth' });
              } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
            title="Lên đầu trang"
          >
            <FaArrowUp color="#fff" size={18} />
          </Button>
          <Button
            variant="primary"
            size="sm"
            style={{
              width: '32px',
              height: '32px',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              backgroundColor: '#0d6efd',
              border: 'none',
              boxShadow: '0 2px 8px rgba(13, 110, 253, 0.15)',
              color: '#fff',
              fontSize: 18,
              transition: 'all 0.2s'
            }}
            onClick={() => {
              const panel = document.querySelector('.main-panel');
              if (panel) {
                panel.scrollTo({ top: panel.scrollHeight, behavior: 'smooth' });
              } else {
                window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
              }
            }}
            title="Xuống cuối trang"
          >
            <FaArrowDown color="#fff" size={18} />
          </Button>
        </div>

        <Modal show={showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Table Settings</h6>
                <Form.Check
                  type="switch"
                  id="stick-header"
                  label="Stick Header (Freeze table header when scrolling)"
                  checked={this.state.stickHeader}
                  onChange={this.handleStickHeaderToggle}
                  className="mb-2"
                />
              </div>
              <hr />
              <div className="mb-3">
                <h6>Column Visibility</h6>
                {Object.entries(columnVisibility).map(([column, isVisible]) => (
                  <Form.Check
                    key={column}
                    type="switch"
                    id={`column-${column}`}
                    label={column.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                    checked={isVisible}
                    onChange={() => {
                      const newColumnVisibility = {
                        ...columnVisibility,
                        [column]: !isVisible
                      };
                      const { isRnd, isSale } = this.getRouteType();
                      localStorage.setItem(isRnd ? 'sesProductColumnVisibilityRnd' : isSale ? 'sesProductColumnVisibilitySale' : 'sesProductColumnVisibility', JSON.stringify(newColumnVisibility));
                      this.setState({ columnVisibility: newColumnVisibility });
                    }}
                    className="mb-2"
                  />
                ))}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    products: state.sesProductReducer.products,
    totalCount: state.sesProductReducer.totalCount,
    user: state.authenReducer.user
  };
};

export default connect(mapStateToProps, {
  getSESProducts,
  deleteSESProduct,
  setSESProducts
})(SESProductListWrapper); 